// LIST
export const FETCH_VACCINATION = "app/VACCINATION/FETCH_VACCINATION";
export const FETCH_VACCINATION_SUCCESS =
  "app/VACCINATION/FETCH_VACCINATION_SUCCESS";
export const FETCH_VACCINATION_FAILURE =
  "app/VACCINATION/FETCH_VACCINATION_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/VACCINATION/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/VACCINATION/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/VACCINATION/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_VACCINATION = "app/VACCINATION/ADD_VACCINATION";
export const ADD_VACCINATION_SUCCESS =
  "app/VACCINATION/ADD_VACCINATION_SUCCESS";
export const ADD_VACCINATION_FAILURE =
  "app/VACCINATION/ADD_VACCINATION_FAILURE";

// EDIT
export const EDIT_VACCINATION = "app/VACCINATION/EDIT_VACCINATION";
export const EDIT_VACCINATION_SUCCESS =
  "app/VACCINATION/EDIT_VACCINATION_SUCCESS";
export const EDIT_VACCINATION_FAILURE =
  "app/VACCINATION/EDIT_VACCINATION_FAILURE";

// DELETE
export const DELETE_VACCINATION = "app/VACCINATION/DELETE_VACCINATION";
export const DELETE_VACCINATION_SUCCESS =
  "app/VACCINATION/DELETE_VACCINATION_SUCCESS";
export const DELETE_VACCINATION_FAILURE =
  "app/VACCINATION/DELETE_VACCINATION_FAILURE";

// MODAL
export const TOGGLE_VACCINATION_MODAL =
  "app/VACCINATION/TOGGLE_VACCINATION_MODAL";
